"use strict";
/**
 * params.ts
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.hashes = exports.namedCurves = void 0;
exports.namedCurves = {
    'P-256': { indutnyName: 'p256', nodeName: 'prime256v1', payloadSize: 32 },
    'P-384': { indutnyName: 'p384', nodeName: 'secp384r1', payloadSize: 48 },
    'P-521': { indutnyName: 'p521', nodeName: 'secp521r1', payloadSize: 66 },
    'P-256K': { indutnyName: 'secp256k1', nodeName: 'secp256k1', payloadSize: 32 },
};
exports.hashes = {
    'SHA-256': { nodeName: 'sha256' },
    'SHA-384': { nodeName: 'sha384' },
    'SHA-512': { nodeName: 'sha512' },
    'SHA-1': { nodeName: 'sha1' }, //, hashSize: 20},
};
//# sourceMappingURL=params.js.map